<template>
  <div class="industry-norms">
    <div
      class="banner"
      v-lazy:background-image="{
        src: require('../aiImg/ing_bj_bs@2x.png'),
        loading: require('../aiImg/ing_bj_bs@2x.png'),
      }"
    ></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.industry-norms {
  background-color: #fff;
  min-width: 1200px;
  position: relative;
  width: 100%;
  height: auto;
  margin: 0px auto;
  background-color: #fff;
  .banner {
    width: 100%;
    height: 1110px;
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>
